let initialized = false;
let observer = null;

export function initDexignLabNav() {
  if (initialized) return () => {};

  const main = document.querySelector('#main-wrapper');
  const burgerBtn = document.querySelector('.nav-control');
  const burgerIcon = document.querySelector('.hamburger');

  // Wait until elements exist
  if (!main || !burgerBtn || !burgerIcon) {
    const id = requestAnimationFrame(() => initDexignLabNav());
    return () => cancelAnimationFrame(id);
  }

  const syncMini = () => {
    const mini = main.classList.contains('menu-toggle');
    document.documentElement.classList.toggle('sidebar-mini', mini);
  };

  const onClick = () => {
    main.classList.toggle('menu-toggle');
    burgerIcon.classList.toggle('is-active');
    syncMini();
  };

  burgerBtn.addEventListener('click', onClick);

  observer = new MutationObserver(syncMini);
  observer.observe(main, { attributes: true, attributeFilter: ['class'] });

  initialized = true;
  syncMini();

  // Cleanup
  return () => {
    try {
      burgerBtn.removeEventListener('click', onClick);
    } catch {}
    try {
      observer && observer.disconnect();
    } catch {}
    initialized = false;
  };
}
